import isIframeLogin from './isIframeLogin';

const sendIframeLoginSuccessMessage = (query) => {
  // Iframe Login Handling
  try {
    const container = window.top;
    if (isIframeLogin(query)) container.postMessage('login-successful');
  } catch {
    /**/
  }
};

export default sendIframeLoginSuccessMessage;
